import { useDispatch, useSelector } from 'react-redux';
import { RootState, toggleTheme, setTheme, setPrimaryColor, setSecondaryColor } from '@/store';

export const useTheme = () => {
  const dispatch = useDispatch();
  const { mode, colors } = useSelector((state: RootState) => state.theme);

  const handleToggleTheme = () => {
    dispatch(toggleTheme());
  };

  const handleSetTheme = (themeMode: 'light' | 'dark') => {
    dispatch(setTheme(themeMode));
  };

  const handleSetPrimaryColor = (color: string) => {
    dispatch(setPrimaryColor(color));
  };

  const handleSetSecondaryColor = (color: string) => {
    dispatch(setSecondaryColor(color));
  };

  return {
    mode,
    colors,
    toggleTheme: handleToggleTheme,
    setTheme: handleSetTheme,
    setPrimaryColor: handleSetPrimaryColor,
    setSecondaryColor: handleSetSecondaryColor,
    isDarkMode: mode === 'dark',
    isLightMode: mode === 'light',
  };
};